import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import { LayoutContext } from 'App/Layout/store'
import { JsonEditor as Editor } from 'jsoneditor-react';
import 'jsoneditor-react/es/editor.min.css';
import ace from 'brace';
import 'brace/mode/json';
import 'brace/theme/github';
import pdfMake from "pdfmake/build/pdfmake";
import _ from 'underscore';
import { useAuth } from "react-oidc-context";

const styles = theme => ({
  fab: {
    position: 'relative',
    left: "85%"
  },
  root: {
    flexGrow: 1,
  },
  jsoneditor: {
    height: "100%!important"
  }

});

function EditarPlantillas(props) {
  const { classes } = props;
  const layoutContext = useContext(LayoutContext);
  const [plantilla, cambiaPlantilla] = useState(null);
  const [plantillaTxt, cambiaPlantillaTxt] = useState("");
  const [pdfurl, cambiaPdfUrl] = useState(null);
  const [error, cambiaError] = useState(null);
  const auth = useAuth();
  var editor = React.createRef();

  useEffect(() => {
    axios.get('/api/imprimir/descomprimir/' + props.match.params.id).then(resp => {
      cambiaPlantilla(resp);
      cambiaPlantillaTxt(JSON.stringify(resp));
      procesaPdf(resp)
    }).catch(e => console.error(e))
  }, []);

  var procesaPdf = (e) => {
    try {
      var txt = editor.current.jsonEditor.getText();
      cambiaPlantillaTxt(txt)
      e = JSON.parse(txt)
      cambiaPlantilla(e)
    } catch (err) {
      cambiaError(err.toString());
    } try {
      pdfMake.createPdf(e).getDataUrl((outDoc) => {
        cambiaPdfUrl(outDoc);
      })
      cambiaError("");
    } catch (err) {
      cambiaError(err.toString());
    }
  }

  var enviar = e => {
    e.preventDefault();
    axios.post("/api/imprimir/comprimir", { id: props.match.params.id, texto: plantillaTxt }).then(() => alert("ok")).catch(e => /*alert(e.response.data.Mensaje)*/{})
  }

  return (
    layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Admin) ?
    <Grid container spacing={24} className={"editor-grid-parent"}>
      <Grid xs={10}>
        {error}
      </Grid>
      <Grid xs={1} style={{ textAlign: "right", margin: "10px" }}>
        <button onClick={enviar}>Guardar</button>
      </Grid>
      <Grid xs={6} className={"editor-grid"}>
        {plantilla ?
          <Editor
            value={plantilla}
            onChange={_.debounce(procesaPdf, 500)}
            mode={Editor.modes.code}
            ace={ace}
            theme="ace/theme/github"
            ref={editor}
          /> : null}
      </Grid>
      <Grid xs={6}>
        <iframe src={pdfurl} style={{ width: "100%", height: "100%" }} />
      </Grid>

    </Grid>:
    <h5>No Autorizado</h5>
  )
}

EditarPlantillas.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(EditarPlantillas);